/* eslint-disable react/react-in-jsx-scope */
import Grid from "components/Common/Grid"
import { useFormik } from "formik"
import { post, put } from "helpers/api_helper"
import { clearCEP, clearCNPJ } from "helpers/clearCepAndCNPJValues"
import { useEffect, useState } from "react"
import * as Yup from "yup"
import "./../../CompanysForm.css"

// Função para aplicar máscara de CNPJ
const formatCNPJ = (value) => {
  const numbers = value.replace(/\D/g, '')
  return numbers.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
}

// Função para aplicar máscara de CEP
const formatCEP = (value) => {
  const numbers = value.replace(/\D/g, '')
  return numbers.replace(/^(\d{5})(\d{3})$/, '$1-$2')
}

const validationSchema = Yup.object({
  CNPJ: Yup.string()
    .matches(/^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/, "CNPJ deve estar no formato XX.XXX.XXX/XXXX-XX.")
    .required("CNPJ é obrigatório."),
  NomeReceita: Yup.string(),
  PalavraChave: Yup.string(),
  Endereco: Yup.string(),
  CEP: Yup.string()
    .matches(/^\d{5}-\d{3}$/, "CEP deve estar no formato XXXXX-XXX."),
  Cidade: Yup.string().max(100, "Cidade não pode ter mais que 100 caracteres."),
  UF: Yup.string().length(2, "UF deve ter 2 caracteres."),
  Email: Yup.string()
    .email("Email inválido")
    .max(100, "Email não pode ter mais que 100 caracteres."),
  Corretoras: Yup.string(),
  Clientes: Yup.string(),
  Status: Yup.string(),
  RangeLeads: Yup.string().max(
    100,
    "Range de Leads não pode ter mais que 100 caracteres."
  ),
})

const B3Form = ({
  companySelected,
  setCompanySelected,
  setShowList,
  setCurrentPage,
}) => {
  const [isLoadingCNPJ, setIsLoadingCNPJ] = useState(false)
  const initialValues = {
    CNPJ:
      companySelected !== null && companySelected.CNPJ !== null
        ? formatCNPJ(clearCNPJ(companySelected.CNPJ))
        : "",
    NomeReceita:
      companySelected !== null && companySelected.NomeReceita !== null
        ? companySelected.NomeReceita
        : "",
    PalavraChave:
      companySelected !== null && companySelected.PalavraChave !== null
        ? companySelected.PalavraChave
        : "",
    Endereco:
      companySelected !== null && companySelected.Endereco !== null
        ? companySelected.Endereco
        : "",
    CEP:
      companySelected !== null && companySelected.CEP !== null
        ? formatCEP(clearCEP(companySelected.CEP))
        : "",
    Cidade:
      companySelected !== null && companySelected.Cidade !== null
        ? companySelected.Cidade
        : "",
    UF:
      companySelected !== null && companySelected.UF !== null
        ? companySelected.UF
        : "",
    Email:
      companySelected !== null && companySelected.Email !== null
        ? companySelected.Email
        : "",
    Corretoras:
      companySelected !== null && companySelected.Corretoras !== null
        ? companySelected.Corretoras
        : "",
    Clientes:
      companySelected !== null && companySelected.Clientes !== null
        ? companySelected.Clientes
        : "",
    Status:
      companySelected !== null && companySelected.Status !== null
        ? companySelected.Status
        : "Ativo",
    RangeLeads:
      companySelected !== null && companySelected.RangeLeads !== null
        ? companySelected.RangeLeads
        : "",
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: values => {
      // Limpar máscaras antes de enviar para a API
      const cleanValues = {
        ...values,
        CNPJ: clearCNPJ(values.CNPJ),
        CEP: clearCEP(values.CEP),
        Status: values.Status === "Ativo" ? true : false
      }
      
      if (companySelected === null) {
        handleCreateNewCompany(cleanValues)
      } else {
        handleEditCompany(cleanValues)
      }
    },
  })

  const handleCreateNewCompany = async payload => {
    const url =
      `${process.env.REACT_APP_API_INT_LEADS}/api/empresas-b3`

    try {
      const response = await post(url, payload)
      console.log(response)
      alert("A empresa foi cadastrada com sucesso!")
      setShowList(true)
      setCurrentPage(1)
      return
    } catch (error) {
      if (error.response?.status === 400) {
        alert(error.response.data.message)
        return
      } else {
        alert(
          "Algo de errado aconteceu! Tente mais tarde ou verifique sua internet"
        )
        return
      }
    }
  }

  const handleEditCompany = async payload => {
    const url = `${process.env.REACT_APP_API_INT_LEADS}/api/empresas-b3/${companySelected.Id}`

    try {
      const response = await put(url, payload)
      console.log(response)
      alert("A empresa foi editada com sucesso!")
      handleCancelEdditing()
      setCurrentPage(1)
      return
    } catch (error) {
      if (error.response?.status === 400) {
        alert(error.response.data.message)
        return
      } else {
        alert(
          "Algo de errado aconteceu! Tente mais tarde ou verifique sua internet"
        )
        return
      }
    }
  }

  const handleCancelEdditing = () => {
    setCompanySelected(null)
    setShowList(true)
  }

  // Função para buscar dados do CNPJ na API BrasilAPI
  const searchCNPJ = async cnpj => {
    setIsLoadingCNPJ(true)
    try {
      const response = await fetch(
        `https://brasilapi.com.br/api/cnpj/v1/${cnpj}`
      )
      const data = await response.json()
      if (data && !data.message) {
        formik.setValues({
          ...formik.values,
          NomeReceita: data.razao_social || data.nome_fantasia || "",
          Endereco: `${data.logradouro || ""}${data.numero ? ", " + data.numero : ""}`.trim(),
          Cidade: data.municipio || "",
          UF: data.uf || "",
          CEP: data.cep ? formatCEP(data.cep) : "",
        })
      } else {
        alert(data.message || "CNPJ não encontrado")
      }
    } catch (error) {
      alert("Erro ao buscar CNPJ. Verifique sua conexão.")
    } finally {
      setIsLoadingCNPJ(false)
    }
  }

  useEffect(() => {
    !companySelected && formik.resetForm({ values: initialValues })
  }, [companySelected])

  // useEffect para autopreenchimento quando CNPJ é inserido
  useEffect(() => {
    if (formik.values.CNPJ) {
      const cnpjNumbers = formik.values.CNPJ.replace(/\D/g, '')
      
      // Buscar dados da empresa quando CNPJ estiver completo
      if (cnpjNumbers.length === 14) {
        searchCNPJ(cnpjNumbers)
      }
    }
  }, [formik.values.CNPJ])

  return (
    <div className="companys-form-container">
      <h1 className="h1-form-title">Preencha o formulário abaixo:</h1>
      <span className="span-form-subtitle">Campos obrigatórios *</span>
      {companySelected !== null && (
        <span className="span-form-edditing">
          Atenção! Você está editando a empresa selecionada!
        </span>
      )}
      <form className="form-companys-container" onSubmit={formik.handleSubmit}>
        <Grid>
          <div className="input-and-label">
            <label className="company-label">CNPJ*</label>
            <input
              type="text"
              className="company-input-field"
              placeholder="XX.XXX.XXX/XXXX-XX"
              name="CNPJ"
              value={formik.values.CNPJ}
              onChange={(e) => {
                const formattedValue = formatCNPJ(e.target.value)
                formik.setFieldValue('CNPJ', formattedValue)
              }}
              onBlur={formik.handleBlur}
              maxLength={18}
            />
            {isLoadingCNPJ && (
              <span className="span-form-loading">Buscando dados...</span>
            )}
            {formik.touched.CNPJ && formik.errors.CNPJ ? (
              <span className="span-form-error-companys">
                {formik.errors.CNPJ}
              </span>
            ) : null}
          </div>
          <div className="input-and-label">
            <label className="company-label">Nome Receita</label>
            <input
              type="text"
              className="company-input-field"
              placeholder="Nome receita"
              name="NomeReceita"
              value={formik.values.NomeReceita}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.NomeReceita && formik.errors.NomeReceita ? (
              <span className="span-form-error-companys">
                {formik.errors.NomeReceita}
              </span>
            ) : null}
          </div>
          <div className="input-and-label">
            <label className="company-label">Palavra chave</label>
            <input
              type="text"
              className="company-input-field"
              placeholder="Palavra chave"
              name="PalavraChave"
              value={formik.values.PalavraChave}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.PalavraChave && formik.errors.PalavraChave ? (
              <span className="span-form-error-companys">
                {formik.errors.PalavraChave}
              </span>
            ) : null}
          </div>
          <div className="input-and-label">
            <label className="company-label">CEP</label>
            <input
              type="text"
              className="company-input-field"
              placeholder="XXXXX-XXX"
              name="CEP"
              value={formik.values.CEP}
              onChange={(e) => {
                const formattedValue = formatCEP(e.target.value)
                formik.setFieldValue('CEP', formattedValue)
              }}
              onBlur={formik.handleBlur}
              maxLength={9}
            />
            {formik.touched.CEP && formik.errors.CEP ? (
              <span className="span-form-error-companys">
                {formik.errors.CEP}
              </span>
            ) : null}
          </div>
          <div className="input-and-label">
            <label className="company-label">Cidade</label>
            <input
              type="text"
              className="company-input-field"
              placeholder="Nome Cidade"
              name="Cidade"
              value={formik.values.Cidade}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.Cidade && formik.errors.Cidade ? (
              <span className="span-form-error-companys">
                {formik.errors.Cidade}
              </span>
            ) : null}
          </div>
          <div className="input-and-label">
            <label className="company-label">UF</label>
            <input
              type="text"
              className="company-input-field"
              placeholder="UF"
              name="UF"
              value={formik.values.UF}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.UF && formik.errors.UF ? (
              <span className="span-form-error-companys">
                {formik.errors.UF}
              </span>
            ) : null}
          </div>
          <div className="input-and-label">
            <label className="company-label">Endereço</label>
            <input
              type="text"
              className="company-input-field"
              placeholder="Endereço"
              name="Endereco"
              value={formik.values.Endereco}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.Endereco && formik.errors.Endereco ? (
              <span className="span-form-error-companys">
                {formik.errors.Endereco}
              </span>
            ) : null}
          </div>
          <div className="input-and-label">
            <label className="company-label">Clientes</label>
            <input
              type="text"
              className="company-input-field"
              placeholder="Clientes"
              name="Clientes"
              value={formik.values.Clientes}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
          <div className="input-and-label">
            <label className="company-label">Corretoras</label>
            <input
              type="text"
              className="company-input-field"
              placeholder="Corretoras"
              name="Corretoras"
              value={formik.values.Corretoras}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
          <div className="input-and-label">
            <label className="company-label">Status</label>
            <select
              className="company-input-field"
              name="Status"
              value={formik.values.Status}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="Ativo">Ativo</option>
              <option value="Inativo">Inativo</option>
            </select>
            {formik.touched.Status && formik.errors.Status ? (
              <span className="span-form-error-companys">
                {formik.errors.Status}
              </span>
            ) : null}
          </div>
          <div className="input-and-label">
            <label className="company-label">Email</label>
            <input
              type="Email"
              className="company-input-field"
              placeholder="Email"
              name="Email"
              value={formik.values.Email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.Email && formik.errors.Email ? (
              <span className="span-form-error-companys">
                {formik.errors.Email}
              </span>
            ) : null}
          </div>
          <div className="input-and-label">
            <label className="company-label">Leads de alcance</label>
            <input
              type="text"
              className="company-input-field"
              placeholder="Leads de alcance"
              name="RangeLeads"
              value={formik.values.RangeLeads}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.RangeLeads && formik.errors.RangeLeads ? (
              <span className="span-form-error-companys">
                {formik.errors.RangeLeads}
              </span>
            ) : null}
          </div>
        </Grid>

        <Grid marginTop={32}>
          <button
            className="btn btn-primary w-md"
            type="submit"
            style={{ height: 40, border: "none" }}
          >
            Enviar
          </button>

          {companySelected !== null && (
            <button
              className="btn btn-primary w-md"
              type="button"
              style={{ backgroundColor: "red", height: 40, border: "none" }}
              onClick={handleCancelEdditing}
            >
              Cancelar
            </button>
          )}
        </Grid>
      </form>
    </div>
  )
}

export default B3Form
